export class MyError extends Error {

    status: number;

    constructor(message: string, status: number = 0){
        super(message)
        this.name = 'MyError';
        this.status = status;
    }
}
